import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';

const template = FlowComponent.html`
    <form action="${'action'}" method="${'method'}" class="space-y-4">
        <slot></slot>
    </form>
`;

export class FlowForm extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        const form = this.root.querySelector('form');

        // Manejo del submit nativo
        form.onsubmit = (e) => this.#handleSubmit(e, form);

        // Hack para Shadow DOM:
        // Detectamos si se hizo click en un elemento type="submit" dentro del slot
        // ya que el evento click burbujea desde el Shadow DOM del botón hasta aquí.
        this.root.addEventListener('click', (e) => {
            // Buscamos si el target original o sus ancestros (dentro del path del evento) es un botón submit
            const path = e.composedPath();
            const submitBtn = path.find(el => 
                el.getAttribute && el.getAttribute('type') === 'submit'
            );

            if (submitBtn) {
                // Si encontramos un botón submit, forzamos el envío del formulario
                // Usamos requestSubmit() para que dispare validaciones y el evento submit
                form.requestSubmit();
            }
        });
    }

    #handleSubmit(e, form) {
        e.preventDefault();
        
        // Recolectamos datos de todos los elementos (nativos y custom con ElementInternals)
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        // Emitimos un evento estandarizado
        this.emit('form:submit', {
            data,
            action: this.getAttribute('action'),
            method: this.getAttribute('method') || 'POST'
        });
    }
}

customElements.define('flow-form', FlowForm);